import { SvgIcon, SvgIconProps } from "@mui/material";

const GasSensorIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 21 21" sx={{ fontSize: 20, ...props.sx }} {...props}>
    <path d="M11.6955 11.7392C16.6886 7.41154 13.2902 2.08533 13.2902 2.08533C13.2902 2.08533 12.8322 6.20471 9.30616 9.26078C4.31306 13.5884 7.71149 18.9146 7.71149 18.9146C7.71149 18.9146 8.16947 14.7952 11.6955 11.7392Z" fill="currentColor"/>
    <path d="M16.5373 15.0468C20.6799 11.4564 17.8603 7.03748 17.8603 7.03748C17.8603 7.03748 17.4804 10.4551 14.555 12.9907C10.4124 16.5811 13.232 21 13.232 21C13.232 21 13.6119 17.5823 16.5373 15.0468Z" fill="currentColor"/>
    <path d="M6.44554 8.00935C10.5881 4.41894 7.76859 0 7.76859 0C7.76859 0 7.38861 3.41767 4.46324 5.95318C0.320643 9.5436 3.14019 13.9625 3.14019 13.9625C3.14019 13.9625 3.52016 10.5449 6.44554 8.00935Z" fill="currentColor"/>
  </SvgIcon>
);

export default GasSensorIcon;

